import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import SkeletongActivityRow from './skeleton-activity-row';
export default function SkeletonGrid() {
    return (_jsx(_Fragment, { children: Array.from({ length: 10 }, function (_elem, index) { return (_jsx(SkeletongActivityRow, {}, index)); }) }));
}
